/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const confirmOrderService = async (data) => {
  return api(`/Sellitback.svc/CreateOrder?CustomerId=${data
    .CustomerId}&CartID=${data.CartID}&Token=${data.Token}&PaymentType=${data.paymentType}&Voucher=0`, {}, 'GET');
};

const confirmOrderForCharityService = async (data) => {
  return api(`/Sellitback.svc/CreateOrderForCharity?CustomerId=${data.CustomerId}&CartID=${data
    .CartID}&Token=${data.Token}&PaymentType=${data.paymentType}&CharityID=${data.CharityID}&Voucher=0`, {}, 'GET');
};

const getCharitiesService = async () => {
  return api('/Sellitback.svc/GetCharities', {}, 'GET');
};


export {
  confirmOrderService,
  confirmOrderForCharityService,
  getCharitiesService,
};
